import React from 'react'
import CollegesLikeThisBanner from './Components/CollegesLikeThisBanner'
import CollegesLikeThisBody from './Components/CollegesLikeThisBody'
import IndexFooter from '../Index/Components/IndexFooter'
// import TopBar from '../ProjectComponents/TopBar'
import { useParams } from 'react-router-dom'
import SEOHelmet from '../ProjectComponents/SEOHelmet'

function CollegesLikeThisPage() {
  const {slug} = useParams();
  const page = 'college';

  return (
    <>  
        <SEOHelmet page={page} collegeId={slug}/>
         {/* topbar */}
         <div className='bg-findColleges main'>
            {/* <TopBar/> */}
            <CollegesLikeThisBanner/>
        </div>
        <CollegesLikeThisBody/>
        
        {/* footer */}
        <IndexFooter/>
    </>
  )
}

export default CollegesLikeThisPage